import { useEffect } from "react";
import BaseLayout from "@/v2/components/BaseLayout";

export default function Gone410() {
  // Signal 410-liknande status till Sentry/analytics. Faktisk HTTP 410
  // hanteras på hostingnivå (CF _headers / route rules).
  useEffect(() => {
    document.title = "410 – Sidan finns inte längre";
  }, []);

  return (
    <BaseLayout
      title="410 – Sidan finns inte längre"
      description="Den här sidan har tagits bort permanent."
      noindex
    >
      <h1 className="k2-h1">Sidan finns inte längre</h1>
      <p>
        Den här sidan har tagits bort permanent och kommer inte tillbaka.
      </p>
      <p>
        <a href="/">Gå till startsidan</a>
      </p>
    </BaseLayout>
  );
}